import { render, staticRenderFns } from "./EducationalGroupStudents.vue?vue&type=template&id=2e0bdd19&"
import script from "./EducationalGroupStudents.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports